var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMRelayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343.244 87.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m",
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.284,25.955h16.044v6.217c1.454-1.903,3.273-3.584,5.457-5.04,2.183-1.456,4.87-2.185,8.062-2.185,3.023,0,5.654.645,7.894,1.933s3.974,3.107,5.205,5.46c1.961-2.296,4.145-4.102,6.555-5.418,2.409-1.315,5.293-1.975,8.655-1.975,4.873,0,8.682,1.442,11.428,4.326,2.745,2.885,4.118,6.986,4.118,12.306v29.82h-16.044v-24.696c0-2.52-.556-4.41-1.669-5.67-1.113-1.26-2.614-1.89-4.506-1.89s-3.45.63-4.674,1.89c-1.223,1.26-1.834,3.15-1.834,5.67v24.696h-16.044v-24.696c0-2.52-.557-4.41-1.67-5.67-1.113-1.26-2.614-1.89-4.505-1.89s-3.435.63-4.631,1.89c-1.197,1.26-1.794,3.15-1.794,5.67v24.696H4.284V25.955Z",
    fill: "#fff",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "RELAY",
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.852,25.203h19.864c5.676,0,10.229,1.716,13.133,4.62,2.244,2.243,3.563,5.478,3.563,9.107v.132c0,7.655-5.279,12.143-12.539,13.463l14.189,18.874h-6.401l-13.397-17.95h-13.199v17.95h-5.214V25.203Zm19.402,23.561c6.93,0,11.879-3.564,11.879-9.504v-.132c0-5.675-4.356-9.106-11.813-9.106h-14.255v18.742h14.188Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.569,25.203h33.393v4.752h-28.18v15.772h25.21v4.752h-25.21v16.168h28.51v4.752h-33.723V25.203Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.789,25.203h5.214v41.379h26.001v4.817h-31.215V25.203Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.734,24.873h4.884l21.052,46.526h-5.609l-5.411-12.209h-25.144l-5.478,12.209h-5.346l21.052-46.526Zm12.869,29.565l-10.493-23.493-10.559,23.493h21.052Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.976,53.119l-19.205-27.916h6.336l15.574,23.099,15.707-23.099h6.071l-19.204,27.85v18.347h-5.279v-18.28Z",
    fill: "#fff",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.282,41.399h12c3.59,0,6.5,2.91,6.5,6.5h0c0,3.59-2.91,6.5-6.5,6.5h-12c-3.59,0-6.5-2.91-6.5-6.5h0c0-3.59,2.91-6.5,6.5-6.5Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.282,42.899h12c2.761,0,5,2.239,5,5h0c0,2.761-2.239,5-5,5h-12c-2.761,0-5-2.239-5-5h0c0-2.761,2.239-5,5-5Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMRelayLogo);
export default __webpack_public_path__ + "static/media/mRelayLogo.3126bfeeb60d41370b4fda13c0cff2c5.svg";
export { ForwardRef as ReactComponent };